// extracted by mini-css-extract-plugin
export var container = "style-module--container--a9ef1";
export var desktopFullWidth = "style-module--desktopFullWidth--30c0a";
export var noPadding = "style-module--noPadding--1b646";
export var slim = "style-module--slim--8773f";
export var ultraSlim = "style-module--ultraSlim--35b9e";